import { keys } from '@classic/Foundation/Analytics/AnalyticsDataLayer'
import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'

export const trackInfinityScrollEvent = ({
  location,
  loadCount,
}: {
  location: 'Pending Bets' | 'Resulted Bets' | 'Debit / Credit' | 'Re-Bet'
  loadCount: number
}) => {
  trackEvent(keys.infinityScroll, { location, loadCount: `${loadCount}` })
}
